<router-outlet></router-outlet>
<!-- Routed components go here -->

<app-loading></app-loading>

<app-alert></app-alert>